import {IFeature} from "../types";

export function getFeatureType (feature: IFeature) {
    let type = feature.properties.geoType || feature.geometry.type;
    type = type.toLowerCase();
    switch (type) {
        case 'point':
            return 'point';
        case 'line':
        case 'linestring':
            return 'line';
        case 'multipolygon':
        case 'polygon':
        default:
            return 'polygon';
    }
}
